import { useRef } from "react";
import { ICE_TIERS } from "./iceServers";

export const useIceServerFailover = () => {
  const tierIndexRef = useRef(0);

  const getCurrentIceConfig = () => {
    return {
      iceServers: ICE_TIERS[tierIndexRef.current].iceServers,
      iceTransportPolicy: "all",
    };
  };

  const escalateTier = () => {
    if (tierIndexRef.current < ICE_TIERS.length - 1) {
      tierIndexRef.current += 1;
      console.warn(
        "Escalating ICE tier to:",
        ICE_TIERS[tierIndexRef.current].name
      );
    }
  };

  const resetTier = () => {
    tierIndexRef.current = 0;
  };

  return {
    getCurrentIceConfig,
    escalateTier,
    resetTier,
    currentTier: () => ICE_TIERS[tierIndexRef.current].name,
  };
};
